import React from 'react';
import PropTypes from 'prop-types';

import Switch from '../../common/Switch';
import InfoIcon from '../../../../images/info-icon.svg';
import { t } from '../../../modules/infra/i18n';

const StatusBar = ({ checked, onChange, username, shopName }) => (
  <div className="c-handoff-bar">
    <div className="c-handoff-bar__spacer" />
    <div className="o-flexbox o-flexbox--content-align-center">
      <span className="c-handoff-bar__info u-fontsize-tiny u-type--semibold u-mr-">
        {t('shops:handoff.info.kiosk_user')} <span className="u-type--bold">{username}</span>
      </span>
      <div className="c-handoff-bar__tooltip">
        <img src={InfoIcon} alt={t('shops:handoff.alt_text')} />
        <span className="u-fontsize-extrasmall u-type--semibold">
          {t('shops:handoff.info.tooltip', { username, shopName })}
        </span>
      </div>
    </div>
    <div className="c-handoff-bar__divider" />
    <div className="o-flexbox o-flexbox--content-align-center">
      <span className="c-handoff-bar__switch-label u-mr-- u-fontsize-tiny u-type--bold u-co-primary">
        {t('shops:handoff.switch_label')}
      </span>
      <Switch
        className="c-switch_teal c-switch_small"
        checked={checked}
        onChange={onChange}
      />
    </div>
  </div>
);

StatusBar.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  shopName: PropTypes.string.isRequired,
};

export default StatusBar;
